import {
  type MarcaRequest,
  type MarcaFormErrors,
  type ModeloRequest,
  type ModeloFormErrors
} from '../types/marca';

export class MarcaValidation {
  static validateMarca(marca: MarcaRequest): MarcaFormErrors {
    const errors: MarcaFormErrors = {};

    if (!marca.descripcion?.trim()) {
      errors.descripcion = 'La descripción es requerida';
    } else if (marca.descripcion.trim().length < 2) {
      errors.descripcion = 'La descripción debe tener al menos 2 caracteres';
    } else if (marca.descripcion.trim().length > 100) {
      errors.descripcion = 'La descripción no puede exceder 100 caracteres';
    }

    return errors;
  }

  static isValidMarca(marca: MarcaRequest): boolean {
    const errors = this.validateMarca(marca);
    return Object.keys(errors).length === 0;
  }

  static validateModelo(modelo: ModeloRequest): ModeloFormErrors {
    const errors: ModeloFormErrors = {};

    if (!modelo.descripcion?.trim()) {
      errors.descripcion = 'La descripción es requerida';
    } else if (modelo.descripcion.trim().length < 2) {
      errors.descripcion = 'La descripción debe tener al menos 2 caracteres';
    } else if (modelo.descripcion.trim().length > 100) {
      errors.descripcion = 'La descripción no puede exceder 100 caracteres';
    }

    if (!modelo.idMarca) {
      errors.idMarca = 'La marca es requerida';
    }

    return errors;
  }

  static isValidModelo(modelo: ModeloRequest): boolean {
    const errors = this.validateModelo(modelo);
    return Object.keys(errors).length === 0;
  }
}